export const MenuEnum = {
  All: "all",
  Own: "own",
  Request: "request",
  History: "history",
};
